export const isSameDay = (date1Str: string, date2Str: string): boolean => {
    const date1 = new Date(date1Str);
    const date2 = new Date(date2Str);

    return (
        date1.getUTCFullYear() === date2.getUTCFullYear() &&
        date1.getUTCMonth() === date2.getUTCMonth() &&
        date1.getUTCDate() === date2.getUTCDate()
    );
};
